import React from 'react';
import './InstructionsModal.scss';

const InstructionsModalForApprover = ({ isOpen, onClose, onContinue, Button }) => {
    if (!isOpen) return null;

    return (
        <div className="instructions-modal">
            <div className="instructions-content">
                <h2>Instructions for Approvers</h2>
                <p>
                    As an approver your role is to review the assessment validated by the assessor and take final action. Please follow the instructions below</p>

                <h3>Review the Assessor's Evaluation</h3>
                <ul>
                    <li>Carefully review the entries made by the assessor</li>
                    <li>You can give feedback directly to the assessor based on their evaluation for each module by adding supporting materials.</li>
                    <li>You can <b>update or modify</b> your feedback <b>at any time</b> before taking the final action (Approve or Send for Rework).</li>
                </ul>
                <h3>Final Approval or Rework</h3>
                <h3>Approve</h3>
                <ul>
                    <li>If the assessment meets all quality and evaluation standards, click <b>Approve.</b></li>
                    <li>Once approved, a final <b>report will be generated</b> for both the <b>user</b> and the <b>assessor.</b></li>
                </ul>

                <h3>Send for Rework</h3>
                <ul>
                    <li>If changes are needed, you can send the assessment back to the assessor and user with your comments for revision.</li>
                    <li>Once the Assessment is Resubmitted, kindly check if the corrections are made and approve it accordingly.</li>
                </ul>
                <h3>Important Notes</h3>
                <ul>
                    <li>Ensure all feedback is constructive and clear.</li>
                    <li>Double-check all inputs and assessment details before final approval.</li>
                    <li>Approval is irreversible and will initiate the report generation process.</li>
                </ul>

                <div className="instructions-buttons">
                    <Button
                        title="Back"
                        onClick={onClose}
                        buttonStyle={{ height: '44px' }}
                        titleStyle={{ fontSize: '20px', fontWeight: '600' }}
                    />
                    <Button
                        title="Continue"
                        onClick={onContinue}
                        buttonStyle={{ height: '44px' }}
                        titleStyle={{ fontSize: '20px', fontWeight: '600' }}
                    />
                </div>
            </div>
        </div>
    );
};

export default InstructionsModalForApprover;
